import type { FC } from 'react';
import type { SvgIconProps } from '@material-ui/core/SvgIcon';
import cx from 'classnames';

import { IconChevron } from 'src/assets/icons/IconChevron';
import { ROTATE_DIRECTION, type RotateDirection } from 'src/data/ui';

import { useStyles } from './useStyles';

interface Props extends SvgIconProps {
  direction?: RotateDirection;
}

export const ChevronIcon: FC<Props> = ({
  className,
  direction = ROTATE_DIRECTION.right,
  ...restProps
}) => {
  const styles = useStyles({ direction });
  return (
    <IconChevron
      className={cx(styles.root, className)}
      {...restProps}
    />
  );
};
